export default __webpack_public_path__ + "static/media/medcur.12e4684f.png";